"use client";
import { TextField, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXs, ColorTextLight, SizeBorderWidthThin, ColorTextError, ColorTextLink, ColorTextDefault, FontLineHeightMd, FontWeightDefault, SpaceSm, RadiusMd, ColorWhite, SpaceXxs, ColorTextMedium, SpaceLg, FontSize100 } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
import { Link } from "../../Navigation/Link/index.js";
const StyledTextField = styled(TextField, {
  shouldForwardProp: () => true
})((props) => {
  var _a;
  const htmlInputProps = (_a = props.slotProps) == null ? void 0 : _a.htmlInput;
  return {
    width: (htmlInputProps == null ? void 0 : htmlInputProps.size) ? "auto" : "100%",
    height: "auto",
    label: {
      background: "none",
      color: `${ColorTextMedium}`,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    },
    "label.MuiFormLabel-filled": {
      paddingRight: `${SpaceXs}`,
      paddingLeft: `${SpaceXxs}`,
      marginLeft: "0px",
      marginRight: "0px",
      background: `${ColorWhite}`
    },
    "label.Mui-focused": {
      background: `${ColorWhite}`,
      color: `${ColorTextLink}`,
      marginLeft: "0px",
      paddingRight: `${SpaceXs}`,
      paddingLeft: `${SpaceXxs}`
    },
    "label.Mui-error": {
      color: `${ColorTextError}`
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: `${ColorWhite}`,
      gap: "0px",
      borderRadius: `${RadiusMd}`,
      paddingRight: `${SpaceSm}`,
      paddingLeft: `${SpaceSm}`,
      ".MuiInputAdornment-positionEnd": {
        button: {
          marginRight: `-${SpaceSm}`,
          ":focus": {
            outline: "2px solid Highlight"
          }
        }
      },
      input: {
        paddingRight: "0px",
        paddingLeft: "0px",
        paddingTop: `${SpaceXs}`,
        paddingBottom: `${SpaceXs}`,
        fontWeight: `${FontWeightDefault}`,
        lineHeight: `${FontLineHeightMd}`,
        wordWrap: "break-word",
        color: `${ColorTextDefault}`
      },
      button: {
        borderTopLeftRadius: "0px",
        borderBottomLeftRadius: "0px"
      }
    },
    "& .MuiOutlinedInput-root.Mui-focused > .MuiOutlinedInput-notchedOutline": {
      borderColor: `${ColorTextLink}`
    },
    "& .MuiOutlinedInput-root.Mui-error > .MuiOutlinedInput-notchedOutline": {
      borderColor: `${ColorTextError}`,
      borderWidth: "2px"
    },
    "& .MuiOutlinedInput-root.Mui-focused.Mui-error > .MuiOutlinedInput-notchedOutline": {
      borderColor: `${ColorTextError}`,
      borderWidth: "2px"
    },
    "& .MuiInputAdornment-positionStart": {
      paddingRight: `${SpaceXs}`,
      marginRight: "0px"
    },
    "& .MuiInputAdornment-positionEnd": {
      paddingLeft: `${SpaceXs}`,
      marginLeft: "0px"
    },
    "& .MuiInputBase-multiline": {
      width: "100%",
      height: "auto"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: `${SizeBorderWidthThin}`,
      borderColor: `${ColorTextLight}`,
      legend: {
        paddingRight: "0px",
        paddingLeft: "0px",
        "& span": {
          paddingRight: "0px",
          paddingLeft: "0px"
        }
      }
    },
    "& .MuiFormHelperText-root": {
      marginRight: `${SpaceXs}`,
      marginLeft: `${SpaceXs}`
    }
  };
});
const tooltipSx = {
  width: "20px",
  height: "20px",
  left: "1.5",
  top: "1.5",
  color: ColorTextLink
};
const TextFieldMainContainer = styled(Box)`
    display: flex;
    gap: ${SpaceXxs};
    flex-direction: column;
    width: 100%;
`;
const TextFieldRowContainer = styled(Box)`
    display: flex;
    gap: ${SpaceXs};
    margin-bottom: ${SpaceLg};

    :last-of-type {
        margin-bottom: 0px;
    }
`;
const TooltipContainer = styled(Box)`
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    display: inline-flex;
    margin-top: ${SpaceXs};
`;
const ErrorsContainer = styled(Box)`
    gap: ${SpaceXxs};
    display: flex;
    flex-direction: column;
`;
const StyledPlainText = styled(Text)`
    color: ${ColorTextLight};
    font-size: ${FontSize100};
    font-weight: ${FontWeightDefault};
    line-height: ${FontLineHeightMd};
    word-wrap: break-word;
`;
const StyledHelpLink = styled(Link)`
    color: ${ColorTextLink};
    font-size: ${FontSize100};
    font-weight: ${FontWeightDefault};
    line-height: ${FontLineHeightMd};
    word-wrap: break-word;
`;
const CardArtStyling = {
  height: "24px",
  width: "38px"
};
export {
  CardArtStyling,
  ErrorsContainer,
  StyledHelpLink,
  StyledPlainText,
  StyledTextField,
  TextFieldMainContainer,
  TextFieldRowContainer,
  TooltipContainer,
  tooltipSx
};
